export default __webpack_public_path__ + "static/media/t4.f13ad390.jpg";